<template>
	<div v-if="canEditRevision()">
		<card>
			<h2>Non puoi modificare questa revisione.</h2>
		</card>
	</div>
	<form
		v-else
		@submit.prevent="checkSignature"
		class="engine-form">
		<div v-if="model.phase !== 'final'">
			<div
				class="upload-button btn btn-info btn-round"
				v-if="model.id && connectionStatus">
				<div v-if="attachmentLoading">
					<i class="fas fa-spin fa-spinner" />
				</div>
				<image-upload
					v-else
					class="add-image w-100"
					drag
					@change="onImageChange"
					button-class=""
					change-text="<i class='fas fa fa-camera'/>"
					select-text="<i class='fas fa fa-camera'/>" />
			</div>
		</div>
		<card>
			<div class="row">
				<div class="col-12 col-md-4 col-lg">
					<div class="form-group">
						<label>Fase intervento</label>
						<el-select
							size="large"
							v-model="model.phase"
							input-class="form-control-lg form-control"
							filterable
							:disabled="account.user.is('worker')"
							placeholder="Seleziona la fase">
								<el-option
								v-for="option in phases"
								:value="option.value"
								:label="option.label"
								:key="option.label"
								>
								</el-option>
						</el-select>
					</div>
				</div>
				<div class="col-12 col-md-4 col-lg">
					<div class="form-group">
						<label>Tipologia intervento</label>
						<el-select
							multiple
							size="large"
							v-model="model.type"
							placeholder="E1,E2,R1,R2,R3">
								<el-option
								v-for="option in revisionTypes"
								:value="option.value"
								:label="option.label"
								:key="option.label"
								>
								</el-option>
						</el-select>
					</div>
				</div>
				<div class="col-12 col-md-4 col-lg">
					<div class="form-group">
						<label>Data intervento</label>
						<el-date-picker
							:picker-options="{
								firstDayOfWeek : 1
							}"
							format="dd/MM/yyyy"
							v-model="model.revisionDate"
							type="date"
							class="form-control-lg"
							size="large"
							placeholder="Seleziona giorno" />
					</div>
				</div>
				<div class="col-12 col-md-4 col-lg" v-if="model.phase==='final' && account.user.is('backoffice')">
					<base-input
						label="Numero rapporto intervento tecnico"
						:error="getError('number')"
						v-model="model.number"
						name="number"
						type="number"
						input-size="form-control-lg"
						placeholder="Numero rapporto intervento tecnico" />
				</div>
				<div class="col-12 col-md-4 col-lg">
					<label for="workersOnRevisions" class="d-block mb-2">
						Tecnici intervenuti
						<!-- {{users.length}}  {{model.workers}} -->
					</label>
					<el-select
						id="workersOnRevisions"
						v-model="model.workers"
						filterable
						multiple
						size="large"
						placeholder="Seleziona i tecnici">
						<el-option
							v-for="(user,$index) in users"
							:key="$index"
							:label="`${user.name} ${user.surname}`"
							:value="user._id"/>
					</el-select>
				</div>
			</div>
		</card>

		<revision-final-form
			:site="site"
			:submit="onSubmitForm"
			:model="model"
			v-if="model.phase==='final' && account.user.is('backoffice') "/>
		<revision-technical-form
			:site="site"
			:model="model"
			v-if="model.phase !=='final'"/>

		<revision-technical-signature
			:model="model"
			:submit="onSubmitForm"
        	:site="site"
        	:key="componentKey"
			:show="sendingSignatureTechnicalForm"/>

		<div class="row justify-content-center">
			<div class="col-12 col-md-4">

				<button class="btn btn-save-action btn-secondary" :disabled="isSaving">
	    			<i class="icon-cloud-upload-94 tim-icons" />
				</button>
				<base-button type="primary" class="w-100 btn-lg" native-type="submit" :disabled="isSaving">
	    			<i class="icon-cloud-upload-94 tim-icons" />
					{{submitMessage}}
				</base-button>
			</div>
		</div>
	</form>
</template>
<style lang="scss">
	.upload-button{
		right: 15px;
		bottom: 15px;
	}
	.btn-save-action{
		right: 90px;
		border-radius: 50%;
		bottom: 15px;		
	}
	.btn-save-action,
	.upload-button{
		position: fixed;
		z-index: 90;
		font-size: 2em;
		padding: 11px 0;
		width: 59px;
		.fileinput-new{
			text-align: center;
			display: block;
			&.thumbnail{
				display: none;
			}
			// display: none;
		}
	}
</style>
<script>
	import {
		ImageUpload,
	} from 'src/components/index';
	import { Select, Option, DatePicker, TimeSelect } from 'element-ui';
	import { mapState, mapActions } from 'vuex'

	import RevisionFinalForm from './RevisionFinalForm.vue'
	import RevisionTechnicalForm from './RevisionTechnicalForm.vue'
	import RevisionTechnicalSignature from './RevisionTechnicalSignature.vue'

	import Compressor  from 'compressorjs'


	export default {
		name : 'revision-form',
		components: {
			[DatePicker.name]: DatePicker,
			[TimeSelect.name]: TimeSelect,
			[Option.name]: Option,
			[Select.name]: Select,
			ImageUpload,
			RevisionFinalForm,
			RevisionTechnicalForm,
			RevisionTechnicalSignature
		},
		computed: {
			...mapState({
				account: state => state.account,
				users: state => state.users.users.docs,
				connectionStatus: state => state.offline.connectionStatus,
			})
		},
		mounted() {
			this.getAllUsers()
			// check if is 
			this.model.workers = this.model.workers.map(worker => typeof worker === "string" ? worker : worker._id)

		},
		watch: {
			users(newValue) {
				console.log(newValue)
			}
		},
		props: {
			isSaving: {
				type: Boolean,
				default: false
			},
			model: Object,
			site: Object,
			onSubmit: Function,
			create: {
				type: Boolean,
				default: false
			},
			submitMessage: {
				type: String,
				default: 'Salva',
			}
		},
		methods: {
			...mapActions('revisions', {
				addAttachment: 'addAttachment',
				deleteAttachment: 'deleteAttachment',
				updateAttachment: 'updateAttachment'
			}),
			...mapActions('users', {
				getAllUsers: 'getAll'
			}),
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
			forceRerender() {
				this.componentKey += 1;  
			},
			async checkSignature() {
				let isValidForm = await this.$validator.validate();
				if (isValidForm) {
					if (this.model.sendTechnicalReport !== undefined && this.model.sendTechnicalReport){
						this.sendingSignatureTechnicalForm = true;
						this.forceRerender()
					}else{
						//controllo che sia stata fatta la firma
						this.sendingSignatureTechnicalForm = false;
						this.onSubmitForm();
					}
				}
			},
			closeModal() {
				this.sendingSignatureTechnicalForm = false
			},
			canEditRevision(){
				
				return this.model._id &&
					!this.account.user.is("backoffice") && 
					this.model.phase==='technical' && 
					this.account.user._id !== this.model.author;
			},
			async onSubmitForm(){
				this.sendingSignatureTechnicalForm = false;
				this.onSubmit();
			},
			async onImageChange(attachment) {
				if (attachment){
					this.attachmentLoading = true;
					// attachment = optimizeImage(attachment)
					const img = new Compressor(attachment,{
						maxHeight:1440,
						maxWidth:1440,
						quality: 0.7,
						success: async( res ) => {
							await this.addAttachment({
								revisionId : this.$route.params.id,
								attachment:res
							});
							this.attachmentLoading = false;
						},
						error: async (err) => {
							await this.addAttachment({
								revisionId : this.$route.params.id,
								attachment
							});
							this.attachmentLoading = false;
						}
					});
				}
			},
		},
		data() {
			return {
				attachmentLoading: false,
				componentKey: 0,
				sendingSignatureTechnicalForm: false,
				revisionTypes: [{
					value: 'E1',
					label: 'E1'
				},{
					value: 'E2',
					label: 'E2'
				},{
					value: 'R1',
					label: 'R1'
				},{
					value: 'N1',
					label: 'N1'
				},{
					value: 'R2',
					label: 'R2'
				},{
					value: 'R3',
					label: 'R3'
				}],
				phases: [{
					value: 'technical',
					label: 'Intervento tecnico'
				},{
					value: 'final',
					label: 'Revisione amministrativa'
				}]
			}
		}
	}
</script>